export default {
  name: 'quickLinks',
  components: {},
  props: ['quickLinkList'],

  data() {
    return {
      currentUrl: '',
    };
  },
  methods: {
    getRelativeUrl() {
      const fullUrl = window.location.href;
      const url = new URL(fullUrl);
      const path = url.pathname;
      const search = url.search;
      this.currentUrl = path + search;
    },
  },
  mounted() {
    this.getRelativeUrl();
  },
}; 
